// Module
var code = `<div data-bind="compose: { model: browserAlert }"></div>
<div class="on-base-background">
    <h2 class="margin-bottom-xs margin-top-xs">
        <strong class="margin-right">1.</strong> Welcome
    </h2>
    <p class="margin-top-xs margin-bottom">
        This Setup Wizard will assist you with setting up your RavenDB server.<br>
        First, select whether to set up a new cluster from scratch or continue the setup using an existing Setup Package.
    </p>
</div>
<div class="row flex-row welcome">
    <div class="col-sm-6 flex-vertical">
        <div class="panel flex-vertical flex-grow margin-none">
            <div class="padding-md flex-grow">
                <h2 class="text-center margin-bottom text-success">New Cluster</h2>
                <button class="btn btn-icon btn-default" title="Set up a new Cluster" data-bind="click: setupNewClusterFlow, css: { 'btn-selected-success' : model.mode() !== 'Continue' }">
                    <i class="icon-server icon-xl"></i>
                    <p class="lead">New Cluster</p>
                </button>
                <div class="padding">
                    <strong>When to use</strong>:
                    <ul class="list">
                        <li><i class="icon-plus"></i><span>Setting up a new single-node cluster</span></li>
                        <li><i class="icon-plus"></i><span>Setting up a new Cluster:</span></li>
                        <li>
                            <ul>
                                <li>This Setup Wizard will configure the cluster and set up the first node.</li>
                                <li>After that, run the Setup Wizard again per node and select option: 'Use Setup Package'.</li>
                            </ul>
                        </li>
                        <li>
                            <i class="icon-plus"></i>
                            <span>Optionally, create a Setup Package for an external environment<br>i.e. cloud instance, containers, or similar.</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6 flex-vertical">
        <div class="panel flex-vertical flex-grow margin-none">
            <div class="padding-md flex-grow">
                <h2 class="text-center margin-bottom text-info">Use Setup Package</h2>
                <button class="btn btn-icon btn-default" title="Setup using a Setup Package" data-bind="click: useSetupPackageFlow, css: { 'btn-selected-info' : model.mode() === 'Continue' }">
                    <i class="icon-cluster icon-xl"></i>
                    <p class="lead">Use Setup Package</p>
                </button>
                <div class="padding">
                    <strong>When to use</strong>:
                    <ul class="list">
                        <li><i class="icon-plus text-info"></i><span>Only after you have obtained a Setup Package</span></li>
                        <li><i class="icon-plus text-info"></i><span>Setting up a new cluster</span></li>
                        <li><i class="icon-plus text-info"></i><span>Setting up another node in an existing cluster</span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="navigation margin-top margin-bottom flex-horizontal">
    <div class="flex-separator"></div>
    <button class="btn btn-primary" data-bind="click: goToNextView">
        <span>Next</span> <i class="icon-arrow-right"></i>
    </button>
</div>
<div class="bg-info padding flex-horizontal">
    <div class="margin-right-xs">
        <i class="icon-info icon-lg"></i>
    </div>
    <div class="margin-left-xs">
        <strong>To disable this wizard</strong> and setup the server manually:
        <ul>
            <li>Open the settings.json file located in your RavenDB installation directory</li>
            <li>Change the setup mode to None, e.g. "Setup.Mode: "None"</li>
        </ul>
    </div>
</div>
`;
// Exports
export default code;